import { render, staticRenderFns } from "./interReceivedList.vue?vue&type=template&id=54d80ff5&scoped=true&"
import script from "./interReceivedList.vue?vue&type=script&lang=js&"
export * from "./interReceivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d80ff5",
  null
  
)

export default component.exports